import React, { Fragment } from "react";

//lib;
import { getData } from "common-lib/lib";

const FeatureWithPayTable = ({ payTableData, gameId }) => {
  return getData(payTableData, ["math_data"], [])
    ?.filter(
      (i) =>
        (getData(i, ["SymbolName"]) === "F" ||
          getData(i, ["SymbolName"]) === "SC") &&
        !getData(i, ["SymbolPays"]).every((v) => v === 0)
    )
    ?.slice(0, 1)
    ?.map((v) => (
      <div className="half" key={getData(v, ["SymbolID"])}>
        <div className="list">
          {[]
            .concat(getData(v, ["SymbolPays"], []))
            ?.reverse()
            ?.filter((v, k, array) => {
              if (
                gameId === "248" ||
                gameId === "TA35" ||
                gameId === "6007" ||
                gameId === "TA50" ||
                gameId === "246"
              ) {
                return array.length - k < 7;
              } else return array;
            })
            ?.map((v, k, array = getData(v, ["SymbolPays"])) => (
              <Fragment key={k}>
                {v !== 0 && (
                  <div key={k}>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "40px",
                        color: "#fff",
                        marginLeft: "0",
                      }}
                    >
                      {array.length - k}
                      <span
                        style={{
                          color: "#fff",
                          marginLeft: "0",
                          paddingLeft: "3px",
                        }}
                      >
                        {(gameId === "248" ||
                          gameId === "TA35" ||
                          gameId === "6007" ||
                          gameId === "TA50" ||
                          gameId === "246") &&
                          array.length - k === 6 &&
                          "↑"}
                      </span>
                    </span>
                    <span
                      style={{
                        color: "#fff",
                        marginLeft: "0",
                      }}
                    >
                      -
                    </span>
                    <span style={{ marginLeft: "10px" }}>{`${v}X`}</span>
                  </div>
                )}
              </Fragment>
            ))}
        </div>
      </div>
    ));
};

export default FeatureWithPayTable;
